<template>
  <div class="authorCenter">
    <Header></Header>
    <div class="authorBox flexible authorBox-big">
      <sidebar></sidebar>
      <div class="writewrap flex">
        <Bread></Bread>
        <div class="right author-right">
          <writerInfo
          v-if="lang === 'en_US' || lang === 'en_ID'"
          class="contract-form mt0"
          :type="1"
          :reviewFlag="false"
          :allowEditForm="allowEditForm"
          :countries="countries"
          :idCardType="idCardType"
          :form="userAuthor"
          @saveInfoFun="saveInfoFun"
          ></writerInfo>
          <chWriterInfo
          v-if="lang === 'zh_CN'"
          class="contract-form mt0"
          :type="1"
          :reviewFlag="false"
          :allowEditForm="allowEditForm"
          :countries="countries"
          :idCardType="idCardType"
          :form="userAuthor"
          @saveInfoFun="saveInfoFun"
          ></chWriterInfo>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNormalInfo,changeNormalInfo,} from 'apiurl/author';
import { isAccount } from "utils/core/kernel";
import {fileTransferBase64} from '@/utils/index'
export default {
  data () {
    return{
      userId: '',
      countries: [],
      // targetOrgList: [],
      userAuthor:{},
      idCardType:[],
      allowEditForm: true,
      isChange: 2, // 1改变，2没改变
      isBack: false,
      lang: localStorage.getItem('language') || 'en_US',
    }
  },
  watch: {
  },
  created() {
    this.getNormalInfoFun()
    this.isBack=this.$route.query.isBack
  },
  methods: {
    async getNormalInfoFun () {
      let res = await getNormalInfo()
      // console.log(res)
      if (res.success) {
        this.countries = res.data.countries
        this.idCardType = res.data.idCardType
        let info = res.data.authorDto
        info.countryCode =  info.country&&info.country.code?info.country.code:''
        info.targetOrgCode =  info.targetOrg&&info.targetOrg.org?info.targetOrg.org:''
        this.userAuthor=info
        this.userId = info.id
        if (info) {

          // this.form = {
          //   account: info.account,
          //   accountType: info.accountType?info.accountType.toString():'',
          //   bank: info.bank,
          //   name: info.name,
          //   mobile: info.mobile,
          //   whatsapp: info.whatsapp,
          //   email: info.email,
          //   swift: info.swift,
          //   address: info.address,
          //   userName: info.userName,
          //   postalCode: info.postalCode,
          //   bankAddress: info.bankAddress,
          //   bankBranchCode: info.bankBranchCode,
          //   bankPostalCode: info.bankPostalCode,
          //   idImg: info.idImgUrl?info.idImgUrl: '',
          //   idImgUrl: info.idImg,
          //   countryCode: info.countryCode,
          //   targetOrgCode: info.targetOrgCode,
          // }
          // this.getTargetOrg()
        }
      }
    },
    // uploadFun (e, code) {
    //   if (e.target.files.length == 0) {
    //     this.$faild('custom',this.$lang('authorCenter.profile.uploadInfo[0]'))
    //     return false
    //   }
    //   let file = e.target.files[0];
    //   if(file.size<1024*1024*2){
    //     fileTransferBase64(file).then(res=>{
    //       this.form.idImg = res
    //       this.isChange = 1
    //     })
    //   } else {
    //     this.$faild('custom', this.$lang('authorCenter.profile.uploadInfo[1]'))
    //   }
    // },
    saveInfoFun () {
      this.getNormalInfoFun()
    },
    // getTargetOrg () {
    //   if (this.form.countryCode) {
    //     authorlistTargetOrg( {countryCode: this.form.countryCode}).then(res=>{
    //       if (res.success) {
    //         this.targetOrgList = res.data
    //       }
    //     })
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
  @import "@/styles/author.scss";
  .author-info-form,.contract-form{
    margin: 0 50px;
    padding: 30px 0!important;
  }
</style>
